<template>
  <el-scrollbar wrap-class="scrollbar-wrapper">
    <el-menu
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      :background-color="styles.menuBg"
      :text-color="styles.menuTextColor"
      :active-text-color="styles.menuTextActive"
      mode="vertical"
    >
      <sidebar-item v-for="route in permission_routers" :key="route.path" :item="route" :base-path="route.path"/>
    </el-menu>
  </el-scrollbar>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import styles from '@/styles/variables.scss'

export default {
  components: { SidebarItem },
  computed: {
    ...mapGetters([
      'permission_routers',
      'sidebar'
    ]),
    styles() {
      return styles
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  created() {
    console.log('33', this.permission_routers)
  }
}
</script>

<style lang="scss" scoped>
</style>
